import { action } from 'typesafe-actions'
import { NgoTypes } from './types'
import { IAxiosResponse } from '../root.types'
import { Ngo } from '../../application/models/ngo/ngo'

export const resetCreate = () => action(NgoTypes.RESET_CREATE)

// actions de captura de ngoas de um determinado dia
export const loadNgoRequest = () => action(NgoTypes.LOAD_NGO_REQUEST)

export const loadNgoSuccess = (response: IAxiosResponse<Ngo>) => action(NgoTypes.LOAD_NGO_SUCCESS, response)

export const loadNgoFailure = () => action(NgoTypes.LOAD_NGO_FAILURE)

/* Actions para atualizar um ngo existente*/
export const updateNgoRequest = (ngo: Ngo) => action(NgoTypes.UPDATE_NGO_REQUEST, { ngo })

export const updateNgoSuccess = (response: IAxiosResponse<Ngo>) => action(NgoTypes.UPDATE_NGO_SUCCESS, response)

export const updateNgoFailure = () => action(NgoTypes.UPDATE_NGO_FAILURE)

/* Actions para atualizar um ngo existente*/
export const createNgoRequest = (ngo: Ngo) => action(NgoTypes.CREATE_NGO_REQUEST, { ngo })

export const createNgoSuccess = (response: IAxiosResponse<Ngo>) => action(NgoTypes.CREATE_NGO_SUCCESS, response)

export const createNgoFailure = () => action(NgoTypes.CREATE_NGO_FAILURE)

// actions que procura um dado ong
export const findNgoRequest = (ngoId: string) => action(NgoTypes.FIND_NGO_REQUEST, { ngoId })

export const findNgoSuccess = (response: IAxiosResponse<Ngo>) => action(NgoTypes.FIND_NGO_SUCCESS, response)

export const findNgoFailure = () => action(NgoTypes.FIND_NGO_FAILURE)
